import React from "react";

const UploadDocument = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M27.024 9.8H34L26.087 2v6.863c0 .517.42.937.937.937z"
            fill={fill}
        />
        <path className="u_fill"
            d="M24.212 8.863V2H6.677a.938.938 0 00-.938.938V9.25h10.472A5.154 5.154 0 0121.36 14.4v10.88a5.154 5.154 0 01-5.149 5.149H5.74v2.634c0 .518.42.938.938.938h26.386c.517 0 .937-.42.937-.938V11.675h-6.976a2.815 2.815 0 01-2.812-2.812z"
            fill={fill}
        />
        <path className="u_fill"
            d="M19.547 25.28V14.398a3.336 3.336 0 00-3.335-3.336H5.336A3.336 3.336 0 002 14.399v10.88a3.336 3.336 0 003.336 3.336h10.876a3.336 3.336 0 003.335-3.336zm-5.22-6.407a.937.937 0 01-1.327 0l-1.289-1.29v6.81c-.05 1.243-1.826 1.242-1.875 0v-6.81l-1.289 1.29a.938.938 0 01-1.326-1.326l2.89-2.89a.943.943 0 011.325 0l2.89 2.89a.937.937 0 010 1.326z"
            fill={fill}
        />
    </svg>
);

export default UploadDocument;